import { render } from "./FosXtremeBody.vue?vue&type=template&id=de15c2c2&scoped=true"
import script from "./FosXtremeBody.vue?vue&type=script&lang=js"
export * from "./FosXtremeBody.vue?vue&type=script&lang=js"

import "./FosXtremeBody.vue?vue&type=style&index=0&id=de15c2c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de15c2c2"]])

export default __exports__